import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteQueue } from '../../api/production-request-api/index.js';
import { toast } from '@pella/sash-framework';
import { QUERY_KEYS } from '../../data/constants';
import { useAppContext } from '../../providers';

/**
 * Hook containing mutation function for deleting a Queue.
 */
export const useDeleteQueue = () => {
  const queryClient = useQueryClient();
  const { selectedPlant } = useAppContext();

  return useMutation({
    /**
     * mutateFn - Function to call deleteQueue.
     * @param {Pella.ProductionRequestAPI.Queue['id']} id - The ID of the Queue to delete.
     */
    mutationFn: (id) => deleteQueue(id),
    onSuccess: () => {
      toast.success('Queue deleted successfully!');
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.QUEUE_DATA, selectedPlant] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.RESOURCE_DATA, selectedPlant] });
    },
  });
};
